import type { ScreenRect } from "./cuePlacement";

/** Find the closest complete panel position without covering the supplied
 * actor/HUD rectangles. Coordinates are actual render pixels. */
export function placePanelAvoidingRects(preferred: ScreenRect,
  viewport: { width: number; height: number }, obstacles: readonly ScreenRect[],
  margin = 12): ScreenRect | null {
  const maxX = viewport.width - margin - preferred.width;
  const maxY = viewport.height - margin - preferred.height;
  if (maxX < margin || maxY < margin) return null;
  const rects = obstacles.filter(rect => Number.isFinite(rect.left + rect.top + rect.width + rect.height) && rect.width > 0 && rect.height > 0);
  const xs = [preferred.left, margin, maxX], ys = [preferred.top, margin, maxY];
  for (const rect of rects) {
    xs.push(rect.left - preferred.width - margin, rect.left + rect.width + margin);
    ys.push(rect.top - preferred.height - margin, rect.top + rect.height + margin);
  }
  let best: ScreenRect | null = null, distance = Infinity;
  for (const candidateX of xs) for (const candidateY of ys) {
    const left = Math.max(margin, Math.min(maxX, candidateX));
    const top = Math.max(margin, Math.min(maxY, candidateY));
    if (rects.some(rect => left < rect.left + rect.width + margin && left + preferred.width + margin > rect.left &&
      top < rect.top + rect.height + margin && top + preferred.height + margin > rect.top)) continue;
    const d = (left - preferred.left) ** 2 + (top - preferred.top) ** 2;
    if (d < distance) { distance = d; best = { ...preferred, left, top }; }
  }
  return best;
}
